import { render, staticRenderFns } from "./PurchaseAndSaleTab.vue?vue&type=template&id=0d535ffe&scoped=true"
import script from "./PurchaseAndSaleTab.vue?vue&type=script&lang=js"
export * from "./PurchaseAndSaleTab.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAndSaleTab.vue?vue&type=style&index=0&id=0d535ffe&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d535ffe",
  null
  
)

export default component.exports